/*
 * Copyright (c) 2019 3will Corporation and others.
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the 3will License v1.0
 * which accompanies this distribution, and is available at
 *
 *     http://www.3will.cn/licenses/license-v1.0
 *
 * Contributors:
 *    3will - initial API and implementation
 */
import { BfAppContext, BfPageStore, newEqualCondition } from '@tw/tw-runtime';
import {
  ProductGoodsDTO,
  SaleDocOrderDTO,
  SaleDocOrderRestApiService,
  SaleOrderDeatilNodeModel,
  SaleOrderItemDTO,
  SaleOrderItemRestApiService,
  SaleOrderRestApiService,
  SaleOrderService
} from '@tw/clvip-api-gen';

import { ROUTE_NAMES } from '@/app/navigation/route-names';
import { SettingHistoryOrderNewStoreState } from './type';

export class SettingHistoryOrderNewStore extends BfPageStore<SettingHistoryOrderNewStoreState> {
  private static instance = null;

  private saleOrderService: SaleOrderRestApiService;

  private orderDocService: SaleDocOrderRestApiService;

  private orderItemService: SaleOrderItemRestApiService;

  private orderFuncService: SaleOrderService;

  constructor() {
    super({
      pluginOptions: {
        devTools: {
          name: 'setting/history-order-new'
        }
      }
    });
    const api = BfAppContext.getInstance().getApiService();
    this.saleOrderService = new SaleOrderRestApiService(api);
    this.orderDocService = new SaleDocOrderRestApiService(api);
    this.orderItemService = new SaleOrderItemRestApiService(api);
    this.orderFuncService = new SaleOrderService(api);
  }

  public static getInstance(): SettingHistoryOrderNewStore {
    if (!this.instance) {
      this.instance = new SettingHistoryOrderNewStore();
    }
    return this.instance;
  }

  async onLoad() {
    this.setLoading(true);
    try {
      await this.fetchListData();
    } finally {
      this.setLoading(false);
    }
  }

  async fetchListData() {
    this.setLoading(true);
    const userInfo = this.appContext.getUserStore().getState().userInfo;
    const orders = await this.saleOrderService.query({
      noPaging: true,
      conditions: [newEqualCondition(SaleOrderRestApiService.ORDER_EMPLOYEE, userInfo.employee.id)]
    });

    const datas: {
      order: SaleDocOrderDTO;
      goodsInfo: SaleOrderItemDTO[];
    }[] = [];

    await Promise.all(
      orders.rows.map(async (order) => {
        const orderItems = await this.orderItemService.query({
          noPaging: true,
          conditions: [newEqualCondition(SaleOrderItemRestApiService.ORDER_ID, order.id)]
        });
        console.log('orderItems', orderItems);
        datas.push({
          order,
          goodsInfo: orderItems.rows
        });
      })
    );

    console.log('orders', datas);

    this.setState({
      datas: datas
    });
    this.setLoading(false);
  }

  async onLoadOrder(orderId: string): Promise<SaleOrderDeatilNodeModel[]> {
    this.setLoading(true);
    try {
      // 工单详情的分组查询返回
      const orderGoodsTreeData = await this.orderFuncService.detailByGroup({
        id: orderId
      });

      console.log('orderFuncService', orderGoodsTreeData);
      this.setLoading(false);
      return orderGoodsTreeData;
    } catch (error) {
      this.setLoading(false);
      return [];
    }
  }

  /**
   * 列表点击事件
   * @param item
   */
  async onGoodClick(id: string, mode: 'edit' | 'view') {
    this.routeService.push({
      path: ROUTE_NAMES.GiftGiftInfo,
      query: {
        id: id,
        mode: mode
      }
    });
  }
}
